import { toEventScope } from './event-scope';
import { asString, asStringArray } from '../http/normalise';
import { ApiClientUser, ApiUserInvite } from './client-user.dto';
import { ClientUser, ClientUserStatus, UserInvite } from './client-user.model';
import { HiveRole, asHiveRole } from './role.model';

const USER_STATUSES: ReadonlySet<string> = new Set<string>([
  'invited',
  'active',
  'suspended',
]);

function asUserStatus(value: unknown): ClientUserStatus {
  if (typeof value === 'string' && USER_STATUSES.has(value)) {
    return value as ClientUserStatus;
  }
  return 'invited';
}

function firstKnownRole(roles: unknown): HiveRole {
  for (const candidate of asStringArray(roles)) {
    const role = asHiveRole(candidate);
    if (role !== null) {
      return role;
    }
  }
  return 'CLIENT_VIEWER';
}

export function mapClientUser(dto: ApiClientUser): ClientUser {
  return {
    id: asString(dto.id) ?? '',
    clientId: asString(dto.clientId),
    email: asString(dto.email) ?? '',
    firstName: asString(dto.firstName) ?? '',
    lastName: asString(dto.lastName) ?? '',
    role: firstKnownRole(dto.roles),
    // [] is unrestricted, not empty. `asStringSet` collapsed both to the same Set, which is the
    // whole reason this field is now a union.
    eventScope: toEventScope(dto.eventScope),
    status: asUserStatus(dto.status),
  };
}

export function mapUserInvite(dto: ApiUserInvite): UserInvite {
  return {
    id: asString(dto.id) ?? '',
    email: asString(dto.email) ?? '',
    firstName: asString(dto.firstName) ?? '',
    lastName: asString(dto.lastName) ?? '',
    role: firstKnownRole(dto.roles),
    // [] is unrestricted, not empty. `asStringSet` collapsed both to the same Set, which is the
    // whole reason this field is now a union.
    eventScope: toEventScope(dto.eventScope),
    sentAt: asString(dto.sentAt) ?? '',
    expiresAt: asString(dto.expiresAt) ?? '',
    acceptedAt: asString(dto.acceptedAt),
  };
}
